import zenObservable from 'zen-observable';

var Observable = zenObservable;

export default Observable;
export { Observable };
//# sourceMappingURL=bundle.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/apollo-link-batch/~/zen-observable-ts/lib/bundle.esm.js
// module id = 345
// module chunks = 0